import { capitalDesignTokens, createTypedSxStyles } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignSelf: 'flex-start',
    width: '100%'
  },
  controls: {
    className: 'no-format',
    style: { display: 'none' }
  },
  headerInfo: {
    display: 'flex',
    padding: '12px',
    backgroundColor: capitalDesignTokens.semanticColors.background.inProgressLight,
    borderRadius: '4px',
    gap: '8px'
  },
  headerInfoText: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
    color: capitalDesignTokens.semanticColors.foreground.secondary
  },
  infoIcon: {
    marginTop: '4px',
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
    color: capitalDesignTokens.semanticColors.callToAction.primaryActionMedium
  },
  switchControlLabel: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    padding: '0px',
    margin: '0px'
  },
  storyFooterTitle: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
  },
  storyFooterDescription: {
    fontSize: capitalDesignTokens.foundations.typography.fontSize.bodySmall,
    color: capitalDesignTokens.semanticColors.foreground.secondary
  }
});
